import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PublicViewLoading() {
  return /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    marginBlockStart: "1000",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      grow: true
    })
  });
}